import "./Footer.css";
import sys32logo from "../../assets/images/sys3222.png"; // Adjust the path as necessary
import { siteConfig } from "../../config/site";
import { useIsDanish } from "../../i18n/LanguageContext";

const Footer = () => {
  const isDa = useIsDanish();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo Section */}
        <div className="footer-section logo-section">
          <img
            src={sys32logo}
            alt="System32 Logo"
            className="footer-logo"
          />
          <p className="footer-cvr">CVR: {siteConfig.cvr}</p>
        </div>

        {/* Branding Section */}
        <div className="footer-section brand">
          <h3>System32</h3>
          <p>
            {isDa
              ? "System32 hjælper organisationer med at designe, integrere, automatisere og styre komplekse systemer på tværs af cloudplatforme, API'er, identitet og forretningsapplikationer."
              : "System32 helps organisations design, integrate, automate, and govern complex systems across cloud platforms, APIs, identity, and business applications."}
          </p>
          <div className="social-icons">
            <a href={siteConfig.linkedinUrl} target="_blank" rel="noopener noreferrer" aria-label="System32 on LinkedIn">
              <i className="fab fa-linkedin-in"></i>
            </a>
            {/* <a href="/"><i className="fab fa-facebook-f"></i></a>

            <a href="/">
              <i className="fab fa-twitter"></i>
            </a>

            <a href="/">
              <i className="fab fa-github"></i>
            </a> */}
          </div>
        </div>

        {/* About Us Section */}
        <div className="footer-section">
          <h4>{isDa ? "Om os" : "About Us"}</h4>
          <ul>
            <li>
              <a href="/about">{isDa ? "Vores historie" : "Our Story"}</a>
            </li>
            <li>
              <a href="/about#team">{isDa ? "Mød teamet" : "Meet the Team"}</a>
            </li>
            <li>
              <a href="/#contact-section">{isDa ? "Kontakt" : "Contact"}</a>
            </li>
          </ul>
        </div>

        {/* Services Section */}
        <div className="footer-section">
          <h4>{isDa ? "Ydelser" : "Our Services"}</h4>
          <ul>
            <li>
              <a href="/services/azure-cloud">Azure Governance</a>
            </li>
            <li>
              <a href="/services/azure">Microsoft Azure</a>
            </li>
            <li>
              <a href="/services/ai-governance">AI Governance</a>
            </li>
            <li>
              <a href="/services/ai-automation">AI Automation</a>
            </li>
            <li>
              <a href="/services/automation">{isDa ? "Automatisering" : "Automation"}</a>
            </li>
            <li>
              <a href="/services/software-development">{isDa ? "Softwareudvikling" : "Software Development"}</a>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-section">
          <h4>{isDa ? "Kontakt" : "Contact Us"}</h4>
          <ul>
            <li>
              <i className="fas fa-envelope"></i> {siteConfig.email}
            </li>
            <li>
              <i className="fas fa-phone"></i> {siteConfig.phoneDisplay}
            </li>
            <li>
              <i className="fas fa-map-marker-alt"></i> {siteConfig.addressLines.join(", ")}
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} System32. {isDa ? "Alle rettigheder forbeholdes." : "All rights reserved."}{" "}
          <a href="/privacy">{isDa ? "Privatlivspolitik" : "Privacy Policy"}</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
